import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e5397902&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=e5397902&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5397902",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\0.资料\\项目\\girdear_mall_center_web\\node_modules\\.store\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e5397902')) {
      api.createRecord('e5397902', component.options)
    } else {
      api.reload('e5397902', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=e5397902&scoped=true", function () {
      api.rerender('e5397902', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vab/components/VabHeader/index.vue"
export default component.exports